import { GraphQLClient } from "graphql-request";

export const mcsGqlClient = new GraphQLClient("/graphql/v1/", {
  headers: (): Record<string, string> => {
    return {
      "Content-Type": "application/json",
    };
  },
});
